import api from '@/utils/api'

export const fetchTrainers = (params) => {
  return api.get('/trainers/', {params: params})
    .then(resp => {
      return (resp.data)
    })
}
export const fetchSimpleAdminTrainers = (params) => {
  return api.get('/trainers/simple/', {params: params})
    .then(resp => {
      return (resp.data)
    })
}
export const getTrainer = (id) => {
  return api.get(`/trainers/${id}/`)
    .then(resp => {
      return (resp.data)
    })
}
export const registerTrainerAdmin = (obj) => {
  return api.post('/users/registration/trainer/', obj)
    .then(resp => {
      return (resp.data)
    })
}

export const updateTrainer = (obj) => {
  var fd = new FormData()
  for (const [key, value] of Object.entries(obj)) {
    if (key === 'avatar_thumbnail' && !(value instanceof File)) {
      continue
    }
    if (value === null) {
      continue
    }
    fd.append(key, value)
  }
  return api.put(`/trainers/${obj.id}/`, fd)
    .then(resp => {
      return (resp.data)
    })
}

export const activateTrainer = (obj) => {
  return api.patch(`/trainers/${obj.id}/`, {is_active: true})
    .then(resp => {
      return (resp.data)
    })
}
export const deactivateTrainer = (obj) => {
  return api.patch(`/trainers/${obj.id}/`, {is_active: false})
    .then(resp => {
      return (resp.data)
    })
}
export const sendMailTrainer = (obj) => {
  return api.post(`/trainers/${obj.id}/resend_email/`, {})
    .then(resp => {
      return (resp.data)
    })
}



// WEBPACK FOOTER //
// ./src/trainers/api.js